import React, { useState, useEffect, useRef } from "react";

export const useSmartLoading = (isLoading: boolean) => {
  const [loading, setLoading] = useState(false);
  const startTimeRef = useRef<any>(null);
  const timeoutRef = useRef<any>(null);

  useEffect(() => {
    if (isLoading) {
      startTimeRef.current = Date.now();
      setLoading(true);
    } else {
      const elapsed = Date.now() - startTimeRef.current;
      const remaining = 500 - elapsed;

      if (remaining > 0) {
        timeoutRef.current = setTimeout(() => {
          setLoading(false);
        }, remaining);
      } else {
        setLoading(false);
      }
    }

    return () => {
      clearTimeout(timeoutRef.current);
    };
  }, [isLoading]);

  return loading;
};
